import React, { useState, useEffect } from 'react';

const SingleImageUploader = ({ register, reset, existingImage, onImageChange }) => {
  const [previewImage, setPreviewImage] = useState(existingImage || null);
  const [isValidImage, setIsValidImage] = useState(true);  // Track if image is valid

  useEffect(() => {
    if (existingImage) {
      setPreviewImage(existingImage);
    }
  }, [existingImage]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const validTypes = ["image/jpeg", "image/png", "image/gif"];
      if (!validTypes.includes(file.type)) {
        setIsValidImage(false);
        setPreviewImage(null);
        if (onImageChange) onImageChange(null);
      } else {
        const reader = new FileReader();
        reader.onloadend = () => {
          const newImage = reader.result;
          setPreviewImage(newImage);
          if (onImageChange) onImageChange(newImage);
          setIsValidImage(true); // Mark the image as valid
        };
        reader.readAsDataURL(file);
      }
    } else {
      setPreviewImage(null);
      reset({ file: '' });
      setIsValidImage(true); // Reset validation on cancel
      if (onImageChange) onImageChange(null);
    }
  };

  const clearPreview = () => {
    setPreviewImage(null);
    reset({ file: '' });
    setIsValidImage(true); // Reset validation on clear
    if (onImageChange) onImageChange(null);
  };

  return (
    <div className="my-5">
      <input type="file" {...register('file')} onChange={handleFileChange} />
      {previewImage && (
        <div className="mt-3">
          <img
            src={previewImage}
            alt="Preview"
            style={{ maxWidth: '100%', maxHeight: '200px' }}
          />
          <button
            type="button"
            className="ml-2 btn btn-sm btn-danger"
            onClick={clearPreview}
          >
            Clear
          </button>
        </div>
      )}
      {!isValidImage && (
        <p className="text-red-500 mt-2">Only JPEG, PNG, and GIF formats are allowed.</p>
      )}
    </div>
  );
};

export default SingleImageUploader;
